import { Stack, Group, ThemeIcon, Text } from "@mantine/core";
import { IconStars } from "@tabler/icons-react";
import { SeedType, Event } from "../../common/events/event.schema";

const USFAEventRating = ({ event }: { event: Event }) => {
  return (
    <Stack>
      {event.usfaEventCode && (
        <Group>
          <ThemeIcon variant="light">
            <IconStars />
          </ThemeIcon>
          <Text size="sm">USFA event code {event.usfaEventCode}</Text>
        </Group>
      )}
      {event.seedType === SeedType.USFA && event.usfaEventRating && (
        <Group>
          <ThemeIcon variant="light">{event.usfaEventRating}</ThemeIcon>
          {event.started && (
            <Text size="sm">USFA event rated {event.usfaEventRating}</Text>
          )}
          {!event.started && (
            <Text size="sm">
              provisional USFA event rating of {event.usfaEventRating}
            </Text>
          )}
        </Group>
      )}
    </Stack>
  );
};
export default USFAEventRating;
